import { createSelector } from '@reduxjs/toolkit';
import { allowedWavesSelector } from '../../auth/selectors/auth.selectors';
import { ServerWaveType } from '../../wave/types/wave.type';

export const WaveAnnotateSelector = (waveType: ServerWaveType) =>
  createSelector(allowedWavesSelector('wavesToAnnotate'), (waves) =>
    waves.has(waveType),
  );
